import React, { Component } from 'react';
import { string, arrayOf } from 'prop-types';
import { Message, Loader, Image, Header } from 'semantic-ui-react';

import getMinistryData from '../components/getMinistryData';
import SocialLinks from '../components/SocialLinks';

const initialState = { ministry: {}, loading: true };

class About extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialState };
  }

  componentDidMount() {
    const { ministryId, languageId } = this.props;
    getMinistryData(ministryId, languageId, 1)
      .then(
        res =>
          res.data.ministry
            ? this.setState({ loading: false, ministry: res.data.ministry })
            : this.setState({ loading: false, err: 'API Fetch Error' })
      )
      .catch(() => this.setState({ loading: false, err: 'API Fetch Error' }));
  }

  render() {
    const { ministry, loading, err } = this.state;
    const { terms } = this.props;
    if (!err) {
      return loading ? (
        <Loader active />
      ) : (
        <div>
          <Image size="medium" src={ministry.image} circular floated="right" />
          <Header as="h2">{terms[2]}</Header>
          <p>{ministry.description}</p>
          <Header as="h2">{terms[4]}</Header>
          <a href={ministry.website}>
            {ministry.website.replace(/^https?:\/\//, '').replace(/\/$/, '')}
          </a>
          <Header as="h2">{terms[5]}</Header>
          <SocialLinks ministry={ministry} />
        </div>
      );
    }
    return <Message negative header="Error" content={err} />;
  }
}

About.propTypes = {
  ministryId: string.isRequired,
  languageId: string.isRequired,
  terms: arrayOf(string).isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./src/Routes/About.jsx